import { currencySchema, Dtos } from "@inrev/common";
import * as z from "zod";
import { defineTool } from "../tool-definition";

export const getSfaaExperience = defineTool({
	name: "get_sfaa_experience",
	description:
		'One SFAA (Surety & Fidelity Association of America) industry series by year, the same series the Market Analytics loss-ratio chart draws: written and earned premium, incurred loss, `lossRatio` (incurred loss over earned premium, a fraction) and `trailingLossRatio` (the same over the last three years, null until three years exist). This is industry data, not the record: attribute it to SFAA. Narrow with `line` ("Contract Surety", "Commercial Surety", "Financial Guaranty"), `subline`, `codeSeries`, or one `sfaaCode`; omit them all for every line together. `codeSeries` is the first character of a code followed by "XX" (e.g. "7XX" for codes 700-799), the grouping the Market Analytics chart opens on; `sfaaCode` overrides it. `location` is "U.S. TOTAL" (default) or a state name in capitals; never add states together, since U.S. TOTAL already includes them. Call again for another line or subline. `availableSfaaCodes` lists the codes under the selection; rank them with `list_ranked_sfaa_codes`. Dollar figures are whole dollars. Loss ratio excludes expenses, so it does not show whether a year was profitable, and written premium moves with both rate and volume. Incurred loss can be negative when recoveries exceed new losses.',
	label: "SFAA experience",
	contexts: ["account", "bond_request", "bond"],
	implementation: "api",
	audience: "model",
	input: z.strictObject({
		line: z.string().min(1).optional(),
		subline: z.string().min(1).optional(),
		codeSeries: Dtos.Admin.SfaaClassExperience.codeSeriesSchema.optional(),
		sfaaCode: z.string().min(1).optional(),
		location: z.string().min(1).default(Dtos.Admin.SfaaClassExperience.US_TOTAL_LOCATION),
		fromYear: z.number().int().optional(),
		toYear: z.number().int().optional(),
	}),
	data: z.strictObject({
		label: z.string(),
		location: z.string(),
		items: z.array(
			z.strictObject({
				year: z.number().int(),
				writtenPremium: currencySchema,
				earnedPremium: currencySchema,
				incurredLoss: currencySchema,
				lossRatio: z.number().nullable(),
				trailingLossRatio: z.number().nullable(),
			}),
		),
		availableSfaaCodes: z.array(z.string()),
	}),
});
